export class Form {
    form_id: number;
    name: string;
    url: number;
    privilege_id: number;
    show_gender:number;
    created_at: string;
    show_accesses: boolean = false;
    show_packs: boolean = false;
    show_accompanying: boolean = false;
    min_accompanying: number;
    max_accompanying: number;
    is_promo: boolean = false;
    status: boolean = false;
    is_closed_form_message: boolean = false;
    currency_id: string;
    show_hotels: boolean = false;
    config_title: string;
    stop_accesses: boolean = false
    stop_accesses_data: { label: string; response: string }[] = [];
    stop_hotel: { label: string; response: string }[] = [];
}